import { cn } from '@/utils/cn';

interface LoadingOverlayProps {
  message?: string;
  overlay?: boolean;
  containerHeight?: string;
  className?: string;
}

export function LoadingOverlay({
  message = 'Carregando...',
  overlay = true,
  containerHeight = 'h-64',
  className,
}: LoadingOverlayProps) {
  if (!overlay) {
    return (
      <div className={cn('flex items-center justify-center', containerHeight, className)}>
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          {message && <p className="text-sm text-muted-foreground">{message}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={cn('relative', containerHeight, className)}>
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center rounded-lg">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          {message && <p className="text-sm text-muted-foreground">{message}</p>}
        </div>
      </div>
    </div>
  );
}

export function LoadingPage({ message = 'Carregando...' }: { message?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
        <p className="text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
